module.exports = __webpack_public_path__ + "static/img/no_data.ceea2135.png";